import styles from "../styles/TaxesView.module.css";

const TaxesView = () => {
  return (
    <div className={styles.container}>
      <h2>Налоги</h2>
      <p>Информация по налоговым отчислениям и декларациям.</p>
    </div>
  );
};

export default TaxesView;
